// Updated Dropdown.jsx
import React, { useState, useRef, useEffect } from 'react';
import arrowClose from "../../assets/kangaroo/arrowclose.png"
import './dropdown.css';
import { ChevronDown, ChevronUp } from 'lucide-react';
import nepal from "../../assets/kangaroo/nepalflag.png"

const Dropdown = ({ items, placeholder = 'Destination', arrowIcon, onSelect, selectedItem, setSelectedItem, width = "100%", phoneNumber, placeholderFlag=false}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  console.log("placeholderFlag is:", placeholderFlag);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (item) => {
    setSelectedItem(item);
    setIsOpen(false);
    if (onSelect) onSelect(item);
  };

  // Extract country code from label (e.g., "Nepal +977" -> "+977")
  const getCountryCode = (label) => {
    const match = label.match(/\+\d+/);
    return match ? match[0] : '';
  };

  return (
    <div className="dropdown-container" ref={dropdownRef} style={phoneNumber ? { width:"auto" } : { width }}>
      <button
        className="dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
        style={phoneNumber ? {
          padding: "0.5rem 12px",
          borderTop: "1.55px solid #687C86",
          borderLeft: "1.55px solid #687C86",
          borderBottom: "1.55px solid #687C86",
          backgroundColor: "#d6dced",
          borderRight: "0",
          borderTopLeftRadius: "8px",
          borderBottomLeftRadius: "8px",
          borderTopRightRadius: "0",
          borderBottomRightRadius: "0",
          whiteSpace: "nowrap",
          width:"auto",
          display: "flex",
          alignItems: "center",
          gap: "8px"
        } : {
          width: width,
          border: "1.55px solid #687C86",
          borderBottom: isOpen ? "1.55px solid #687C86" : "1.55px solid #687C86",
          borderBottomLeftRadius: isOpen ? 0 : "8px",
          borderBottomRightRadius: isOpen ? 0 : "8px",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        type="button"
      >
   <span
  className="dropdown-label"
  style={{ display: "flex", alignItems: "center", gap: "8px" }}
>
  {selectedItem ? (
    // When an item is selected
      <>
    {phoneNumber && selectedItem.flag && (
      <img
        src={selectedItem.flag}
        alt={selectedItem.label}
        style={{
          width: "24px",
          height: "24px",
          objectFit: "cover",
          borderRadius: "50%",
        }}
      />
    )}
    {selectedItem.label}
  </>
  ) : (
    // When nothing is selected: placeholderFlag + placeholder
    <>
      {placeholderFlag && (
        <img
          src={placeholderFlag}
          alt="placeholder-flag"
          style={{
            width: "24px",
            height: "24px",
            objectFit: "cover",
            borderRadius: "50%"
          }}
        />
      )}
      {placeholder}
    </>
  )}
</span>


        
        <div className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>
          <ChevronDown size="2.5rem" />
        </div>
      </button>

      {isOpen && (
        <ul
          className={`dropdown-menu ${isOpen ? "open" : "close"}`}
          style={phoneNumber ? { width: "100%", alignContent:"flex-start", padding:"0px", maxHeight: "300px", overflowY: "auto" } : { width, maxHeight: "300px", overflowY: "auto" }}
        >
          {items.map((item, index) => (
            <li key={item.id}>
              <button
                className="dropdown-item"
                onClick={() => handleSelect(item)}
                role="option"
                aria-selected={selectedItem?.id === item.id}
                style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingLeft: phoneNumber ? "0px" : undefined
  }}
              >
                {phoneNumber && item.flag && (
                  <img 
                    src={item.flag} 
                    alt={item.label} 
                    style={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%' }}
                  />
                )}
                {item.label}
              </button>
              {index < items.length - 1 && <div className="dropdown-divider" />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;